import { render, staticRenderFns } from "./ButtonsList.vue?vue&type=template&id=4cfa6c0e&scoped=true&"
import script from "./ButtonsList.vue?vue&type=script&lang=js&"
export * from "./ButtonsList.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsList.vue?vue&type=style&index=0&id=4cfa6c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa6c0e",
  null
  
)

export default component.exports